import React from "react";
import { experimentalStyled } from "@mui/material";
import { Outlet } from "react-router-dom";
import Header from "./AdminLayout/Header/AdminHeader";
import ProtectedRoute from "../pages/AdminLogin/ProtectedRoute";

const MainWrapper = experimentalStyled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
}));

const MainLayout = () => {
  return (
    <ProtectedRoute>
      <MainWrapper>
        <Header>
          <Outlet />
        </Header>
      </MainWrapper>
    </ProtectedRoute>
  );
};

export default MainLayout;
